<template>
  <el-col
    :span="24"
    class="question_list"
    ref="scrollBox"
    :loading="Qloading">
      <ul class="question_list_scroll">
        <li
            v-for="(qitem) in questions"
            :key="qitem.question_id"
            :class="[`questionItem`, `infinite-list-item`, `Qitem_`+ qitem.question_id ]"
          >
          <component :is="isComponent(qitem.q_category)"
              :params="qitem"
              :class="`question_${qitem.question_id}`"
              @pick="handlePick"
              ref="quesItem"
              v-on="$listeners"
              v-bind="$attrs"
            ></component>
          </li>
      </ul>
      <el-backtop target=".el-main .el-scrollbar__wrap" :bottom="100">
        <div>
          <i class="el-icon-caret-top"></i>
        </div>
    </el-backtop>
  </el-col>
</template>

<script>
import { BASE_TYPE_MAP_EDITOR } from './../constant/index'
import * as QuestionType from './../index'
export default {
  name: 'baseQuest',
  props: {
    questions: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
  },
  watch: {
  },
  computed: { },

  created () {
  },

  data () {
    return {
      Qloading: true
    }
  },

  methods: {
    handlePick (data) {
      this.$emit('pick', data)
    },
    isComponent (type) {
      return QuestionType[BASE_TYPE_MAP_EDITOR[type]]
      // 1: 'RadioSelect',
      // 2: 'MultiSelect',
      // 3: 'TypeText',
      // 4: 'DropSelect',
      // 5: 'Cascade'
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.question_list{
    padding-left: 30px;
    &_scroll{
      /deep/.el-textarea .el-textarea__inner{
        min-height:80px !important;
      }
      .questionItem{
        width: 96%;
        padding: 24px 0px;
        border-bottom: 1px solid #EEEEEE
      }
    }
}
</style>
